import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {PartnerFacility} from "../../../shared/interface/partner-facility";
import {Regional} from "../../../shared/interface/regional";
import {FacilityService} from "../../../shared/services/facility.service";
import {RegionalService} from "../../../shared/services/regional.service";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, takeUntil} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {NgForm} from "@angular/forms";
import {FilterService} from "../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-all-regional-list',
  templateUrl: './all-regional-list.component.html',
  styleUrls: ['./all-regional-list.component.scss']
})
export class AllRegionalListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  initialFilters: any;
  displayedColumns: string[] = ['fullName', 'firstName', 'lastName', 'email', 'phone', 'deleted'];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  dataSource: Regional[] = [];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private regionalService: RegionalService,
    private auth: AuthService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private store: Store<StoreRootState>,
    private filterService: FilterService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.regionalService.getRegionalListSubject()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((result: CountedAndPaginated<Regional>) => {
        this.dataSource = result.items;
        this.totalData = result.pagination.total;
      });
    this.parseFilters();
  }

  ngOnInit(): void {
  }
  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }
  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }
  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      firstName: 'string',
      lastName: 'string',
      deleted: 'int',
    }, filters);
  }
  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  loadListData(): void {
    this.regionalService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.initialFilters);
  }
}
